define('home/views/SettingsWebView',[
    'jquery',
    'underscore',
    'backbone-marionette',

    'home/mixins/withFetchingView',
    'home/models/TimelineFilter',
    'home/templates/settingsWeb',
], function (
    $,
    _,
    Marionette,

    withFetchingView,
    TimelineFilter,
    settingsWebTemplate
) {
    'use strict';

    var SettingsWebView = Marionette.ItemView.extend({
        events: {
            'submit form': 'submitHandler',
            'change input[type=checkbox]': 'changeHandler',
        },

        template: settingsWebTemplate,

        initialize: function () {
            this.listenToOnce(this.collection, 'reset', this.doneFetching);
            this.listenTo(this.collection, 'sync', this.render);
        },

        templateHelpers: function () {
            return {
                showUpvoteNotification: !this.collection.get(TimelineFilter.FILTER_LIKEPOST),
                showInviteNotification: !this.collection.get(TimelineFilter.FILTER_INVITE),
                showRecommendNotification: !this.collection.get(TimelineFilter.FILTER_RECOMMEND),
                showThreadRepliesNotification: !this.collection.get(TimelineFilter.FILTER_THREADREPLIES),
                showMentionsNotification: !this.collection.get(TimelineFilter.FILTER_MENTIONS),
            };
        },

        onRender: function () {
            this.$form = this.$('form');
            this.$checkboxes = this.$form.find('[data-role=filter-checkbox]');
            this.$saveStatus = this.$('[data-role=save-status]');
            this.saveBtn = this.$('[data-role=save-btn]')[0];
        },

        changeHandler: function () {
            var changed = _.chain(this.$checkboxes)
                           .filter(this.hasFilterChanged, this)
                           .value();
            this.saveBtn.disabled = !changed.length;
        },

        doneFetching: function () {
            this.collection.fetched = true;
        },

        isDoneFetching: function () {
            return this.collection.fetched;
        },

        submitHandler: function (ev) {
            ev.preventDefault();

            this.updateStatus('is-saving');

            var promises = _.chain(this.$checkboxes)
                            .filter(this.hasFilterChanged, this)
                            .map(this.updateFilter, this)
                            .value();

            $.when.apply($, promises).done(_.bind(this.updateStatus, this, 'is-saved'));
        },

        hasFilterChanged: function (checkbox) {
            var $checkbox = $(checkbox);
            var showNotification = $checkbox.is(':checked');
            var filterExists = this.collection.get($checkbox.attr('data-filter'));
            return (showNotification && filterExists) || (!showNotification && !filterExists);
        },

        updateFilter: function (checkbox) {
            var $checkbox = $(checkbox);
            var method = $checkbox.is(':checked') ? 'removeFilter' : 'addFilter';
            return this.collection[method]($checkbox.attr('data-filter'));
        },

        updateStatus: function (status) {
            this.$el.find('[data-role=save-status]')
                    .removeClass('is-saving is-saved')
                    .addClass(status);
        },

    });

    withFetchingView.call(SettingsWebView.prototype);

    return SettingsWebView;
});

